import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 수집/판단 정책을 목록을 조회한다.
   * @author najongdang
   * @return {Array} 자원 단위 리스트
   */
  getRscEventRules() {
    return axios.get(`${baseUrl}/settings/common/rule/get-rsc-event-rules.do`);
  },
  /**
   * 이벤트/알람 정책을 목록을 조회한다.
   * @author najongdang
   * @return {Array} 자원 단위 리스트
   */
  getEventAlarmRules(managetypeId) {
    return axios.get(`${baseUrl}/settings/common/rule/get-event-alarm-rules.do`, { params: { managetypeId } });
  },

  /**
   * managetypeId별 이벤트/알람 정책을 목록을 조회한다.
   * @author najongdang
   * @return {Array} 자원 단위 리스트
   */
  getEventAlarmRulesByManagetypeId(managetypeId) {
    return axios.get(`${baseUrl}/settings/common/rule/get-event-alarm-rules-by-managtype-id.do`, { params: { managetypeId } });
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/rule.js